import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { GlobalsService } from './globals';
import { ToolboxService } from './toolbox';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private globals: GlobalsService,
        private toolboxService: ToolboxService
    ) { }

    canActivate(): Observable<boolean> | boolean {
        const token = (this.globals.user) ? this.globals.user.token : undefined;
        if (token) {
            this.toolboxService.listToolbox();
            return this.toolboxService.getCheckView.pipe(map((resp) => {
                return resp;
            }));
        } else {
            alert('Token no valido');
            return false;
        }
    }

}
